import React, { Component } from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

import dog from '../../assets/images/sidebar/dog-3.png';
import flowerIcon from '../../assets/icon/flower.svg';
import handIcon from '../../assets/icon/hand.svg';
import houseIcon from '../../assets/icon/house.svg';

import Button from './../common/button';
import SectionAside from './../common/sectionAside';
import TextAreaFilled from './../common/textAreaFilled';

const Section = Styled.section`
display: grid;
grid-template-columns: 25fr 60fr;
background-color: ${color.tertiary};
height: 100vh;
@media only screen and (max-width: 700px){
grid-template-columns: 1fr;
};
`;

const SectionWrapper = Styled.section`
height: 100vh;
display:grid;
grid-template-rows:  1fr max-content;
place-items:center;
`;

const SectionBody = Styled.section``;

const SectionHeader = Styled.header`
margin: 2rem 0;
`;

const SectionHeading = Styled.h2`
max-width: 30ch;
line-height: 1;
color:${color.primary};
`;

const SectionParagraph = Styled.p`
color:${color.primaryAlt};
a{text-decoration: none; color: ${color.primary};}
margin-top: 2rem;
`;

const SectionFooter = Styled.footer`
width: 100%;
background-color:${color.white};
padding: 1rem;
text-align:center;
&>*{margin:0  0.5rem;}
`;

class ScheduleOne extends Component {
  state = {
    type: '',
  };

  handleSelect = (data) => {
    this.setState({ type: data });
  };

  render() {
    const { type } = this.state;
    const { onNext } = this.props;
    const data = [
      {
        type: 'Dog walk',
        icon: flowerIcon,
        description:
          'We’ll take your pup for a walk and make sure he or she has fresh food and water.',
        price: '15',
        brief: 'Per 30mins walk',
      },
      {
        type: 'Drop-in visit',
        icon: handIcon,
        description:
          'We’ll stop by to snuggle, feed, and play with your pets in the comfort of home.',
        price: '15',
        brief: 'Per 30mins visit',
      },
      {
        type: 'House sitting',
        icon: houseIcon,
        description:
          'We’ll stay overnight with your pet to make sure he or she has round-the-clock love.',
        price: '45',
        brief: 'Per night',
      },
    ];

    return (
      <Section>
        <SectionAside
          items={[
            'A photo update for you along with chat about the service',
            'Notifications of sitter arrival and departure times',
            'Treats for your pet, with your permission of course',
          ]}
          image={dog}
        />
        <SectionWrapper>
          <SectionBody>
            <SectionHeader>
              <SectionHeading>
                We can't wait to see your pet! How can we help?
              </SectionHeading>
            </SectionHeader>
            {data.map((d) => (
              <TextAreaFilled
                key={d.type}
                icon={d.icon}
                title={d.type}
                paragraph={d.description}
                price={d.price}
                brief={d.brief}
                selected={d.type === this.state.type}
                onClick={(d) => this.handleSelect(d)}
              />
            ))}
            <SectionParagraph>
              Want to learn more? <a href="/">Read about our services</a>
            </SectionParagraph>
          </SectionBody>

          <SectionFooter>
            <Button
              type={'light'}
              text={'Back'}
              rounded
              onClick={() => {
                this.props.history.push('/');
              }}
            />
            {type && (
              <Button onClick={onNext} type={'primary'} text={'Next'} rounded />
            )}
          </SectionFooter>
        </SectionWrapper>
      </Section>
    );
  }
}

export default ScheduleOne;
